export const state = {
    userProfileData: null
};

export const mutations = {
    SET_PROFILE_DATA(state, payload) {
        state.userProfileData = payload;
    }
};

export const actions = {
    setProfileData({ commit }, payload) {
        commit('SET_PROFILE_DATA', payload)
    }
}